export default __webpack_public_path__ + "static/media/insta-logo-footer.bd9f0121.svg";